import { RegistrationDataT, RegistrationResponseT } from '../../types';
import { DeserializeT } from '../../types/transform';
import { addressTransform } from '../address/address';
import { maritalInformationTransform } from '../marital-information/marital-information';

export const deserializeRegistration: DeserializeT<RegistrationResponseT, Partial<RegistrationDataT>> = (response) => {
  const address = response.address && addressTransform.deserialize(response.address);
  const maritalInformation = (
    response.marital_information && maritalInformationTransform.deserialize(response.marital_information)
  );

  return {
    address,
    email: response.login,
    firstName: response.first_name,
    lastName: response.last_name,
    maritalInformation,
    phoneNumber: response.phone_number,
  };
};
